module.exports = __webpack_public_path__ + "static/city-reflections-morning-f335aad8d4050856ca58b8193835bc85.jpg";